import { Title } from '@yoast/ui-library';
import type { ReactNode } from 'react';

import TooltipUncontrolled from './TooltipUncontrolled';

interface TitleWithTooltipProps {
  title: string | ReactNode;
  tooltip: string | ReactNode;
  size?: '1' | '2' | '3' | '4' | '5' | '6';
  className?: string;
}

const TitleWithTooltip = ({
  title,
  tooltip,
  size = '3',
  className = '',
}: TitleWithTooltipProps) => {
  // Generate tooltipId from title - convert to string, lowercase, replace spaces with hyphens
  const generateTooltipId = (title: string | ReactNode): string => {
    const titleString = typeof title === 'string' ? title : 'tooltip';
    return `tooltip-${titleString.toLowerCase().replace(/\s+/g, '-')}`;
  };

  const tooltipId = generateTooltipId(title);

  return (
    <div className={`yst-flex yst-items-center yst-justify-between ${className}`}>
      <Title size={size}>{title}</Title>

      <TooltipUncontrolled id={tooltipId}>
        {tooltip}
      </TooltipUncontrolled>
    </div>
  );
};

export default TitleWithTooltip;
